module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: "https://api.novotrips.com/api",
    // API_URL: "http://38.17.55.183/compasscrm2023/api",
    // API_URL: "https://api.compasscrm.travel/api",
  },
};
